import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from '@mui/material';

const ConfirmationDialog = ({ open, handleClose, handleConfirm }) => {
    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle style={{ backgroundColor: '#f5f5f5', fontWeight: 'bold' }}>Confirm Delete</DialogTitle>
            <DialogContent>
                <DialogContentText
                    style={{
                        marginTop: '1rem',
                        padding: '10px 15px',
                        backgroundColor: '#fdecea',
                        color: '#d93025',
                        borderRadius: '8px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        fontWeight: 'bold',
                        fontSize: '0.95rem',
                        border: '1px solid #f5c6cb',
                    }}
                >
                    Deleting this domain's data will also delete the associated user data. Are you sure you want to proceed?                </DialogContentText>
            </DialogContent>
            <DialogActions style={{ paddingRight: 25, paddingBottom: 25 }}>
                <Button onClick={handleClose} color="secondary" variant="outlined" sx={{ fontWeight: "bold" }}>
                    Cancel
                </Button>
                <Button onClick={handleConfirm} color="primary" variant="contained" sx={{ fontWeight: "bold" }}>
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmationDialog;
